// Montant en euros, sans centimes (« 1 200 € ») : l'affichage de la page
// campagne et du formulaire de don partagé.
const FORMAT = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

export const fmtEUR = (v) => FORMAT.format(Number(v || 0));
